import { string } from 'yup'
import { safify } from '../utils/safify'

export const postLength = string().meta({ label: 'How long should the post be?', autoFill: true }).transform(safify)
